import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {NotificationsService} from 'angular2-notifications';
import {ActivatedRoute} from '@angular/router';
import {ModalService} from '../../../services/modalService/modal.service';
import {FeatureComponent} from '../zoomView/features/features.component';
import {LoginService} from '../../../services/login.service';
import _ from 'lodash';
import {UtilsService} from "../../../services/utils.service";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-features',
    templateUrl: './features.component.html',
    styleUrls: ['./features.component.css', '../myreports.component.css']
})

export class FeaturesComponent implements OnInit {
    ruid: string;
    isLicense: boolean;
    isParsed: boolean = Boolean(window.localStorage.getItem('isParsed'));
    features: any = [];
    currentUser: any;
    isLoggedIn = false;
    columns = [
        {
            name: 'featureDescription', desc: this.translate.instant('reports.featuresC.packageFeature'), tooltip: '',
            sort: 'asc', isCurrent: false
        },
        {
            name: 'expireDate', desc: this.translate.instant('reports.featuresC.expiration'), tooltip: this.translate.instant('reports.featuresC.expDate'),
            sort: 'asc', isCurrent: false
        },
        {
            name: 'sessions', desc: this.translate.instant('reports.featuresC.sessions'), tooltip: this.translate.instant('reports.featuresC.userAm'),
            sorter: this.utilService.numberStringTableSorterFactory,
            sort: 'asc', isCurrent: false
        },
        {
            name: 'duration', desc: this.translate.instant('reports.featuresC.totalH'), tooltip: this.translate.instant('reports.featuresC.totalTime'),
            sorter: this.utilService.durationTableSorterFactory,
            sort: 'asc', isCurrent: false
        },
        {
            name: 'averageDuration', desc: this.translate.instant('reports.featuresC.avg'), tooltip: this.translate.instant('reports.featuresC.avgSession'),
            sorter: this.utilService.durationTableSorterFactory,
            sort: 'asc', isCurrent: false
        },
        {
            name: 'denials', desc: this.translate.instant('reports.featuresC.denials'), tooltip: this.translate.instant('reports.featuresC.total'),
            sorter: this.utilService.numberStringTableSorterFactory,
            sort: 'asc', isCurrent: false
        },
        {
            name: 'denialRate', desc: this.translate.instant('reports.featuresC.denialP'), tooltip: this.translate.instant('reports.featuresC.denial'),
            sorter: this.utilService.numberStringTableSorterFactory,
            sort: 'asc', isCurrent: false
        }];

    limitedColumns = [
        this.columns[0],
        this.columns[1]
    ];

    constructor(private apiService: ApiService,
                private route: ActivatedRoute,
                private loginService: LoginService,
                private notifications: NotificationsService,
                private modalService: ModalService,
                private utilService: UtilsService,
                private translate: TranslateService) {
    }

    ngOnInit() {
        this.loginService.isLoggedIn()
            .subscribe((isLoggedIn) => {
                this.currentUser = isLoggedIn;
                this.isLoggedIn = this.currentUser.isLoggedIn;
            });

        this.route.queryParams.subscribe(params => {
            if (params.ruid) {
                this.ruid = params.ruid;
                this.apiService.getSummary(this.ruid)
                    .subscribe((res) => {
                        this.isLicense = res.isLicense;
                        this.apiService.getFeatures(this.ruid)
                            .subscribe((featureRes) => {
                                this.features = featureRes.features;
                            }, (featuresErr) => {
                                this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(featuresErr, this.translate.instant('reports.featuresC.featureFail')));
                            });
                    }, (error) => {
                        this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.invalidRuid')));
                    });
            }
        });
    }

    zoomView() {
        this.modalService.open(FeatureComponent, {
            title: this.translate.instant('reports.featuresC.title'),
            data: {
                features: this.features,
                isLicense: this.isLicense,
                currentUser: this.currentUser,
                ruid: this.ruid
            }
        }).subscribe(model => {
        });
    }

    sortCols(name) {
        const column = _.find(this.columns, {name: name});
        _.each(this.columns, function (column) {
            column.isCurrent = false;
        });
        column.isCurrent = true;

        const sorter = column.sorter ? column.sorter(name) : name;
        const order = column.sort;
        this.features = _.orderBy(this.features, sorter, order);

        let subsorter = sorter;
        _.each(this.features, function (feature) {
            if (feature.components.length > 1) {
                feature.components = _.orderBy(feature.components, sorter, order);
            }
        });

        if (order === 'asc') {
            column.sort = 'desc';
        } else {
            column.sort = 'asc';
        }
    }

    sortingStyle(column) {
        return {
            'sorting-up': column.isCurrent && column.sort === 'asc',
            'sorting-down': column.isCurrent && column.sort === 'desc'
        }
    }

    visibleColumns() {
        return this.isFullReportAllowed()
            ? this.columns
            : this.limitedColumns;
    }

    isFullReportAllowed() {
        return (this.currentUser && this.currentUser.paid) || this.ruid == 'demo';
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/features/features.component.ts